import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import { jsx } from 'react/jsx-runtime';

var Context = /*#__PURE__*/React.createContext(null);
var AccordionDndContext = function AccordionDndContext(_ref) {
  var _ref$canDrag = _ref.canDrag,
    canDrag = _ref$canDrag === void 0 ? function () {
      return true;
    } : _ref$canDrag,
    _ref$canDrop = _ref.canDrop,
    canDrop = _ref$canDrop === void 0 ? function () {
      return true;
    } : _ref$canDrop,
    children = _ref.children,
    onDragEnd = _ref.onDragEnd,
    onDragStart = _ref.onDragStart,
    onDragUpdate = _ref.onDragUpdate;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    placeholderProps = _React$useState2[0],
    setPlaceholderProps = _React$useState2[1];
  var dragDataByItemId = React.useRef({});
  var calculatePlaceholderProps = function calculatePlaceholderProps(draggableId, source, target) {
    var draggedDOM = getDraggableDom(draggableId);
    var droppableDOM = getDroppableDom((target !== null && target !== void 0 ? target : source).droppableId);
    if (!draggedDOM || !droppableDOM) {
      return;
    }
    var _draggedDOM$firstElem = draggedDOM.firstElementChild,
      clientHeight = _draggedDOM$firstElem.clientHeight,
      clientWidth = _draggedDOM$firstElem.clientWidth;
    var sourceIndex = source.index;
    var destinationIndex = (target !== null && target !== void 0 ? target : source).index;
    var childrenArray = Array.from(getDroppableChildrenDom((target !== null && target !== void 0 ? target : source).droppableId));
    var movedItem = childrenArray[sourceIndex];
    childrenArray.splice(sourceIndex, 1);
    var updatedArray = [].concat(_toConsumableArray(childrenArray.slice(0, destinationIndex)), [movedItem], _toConsumableArray(childrenArray.slice(destinationIndex + 1)));
    var computedDroppableDOMStyles = window.getComputedStyle(droppableDOM);
    var clientY = parseFloat(computedDroppableDOMStyles.paddingTop) + updatedArray.slice(0, destinationIndex).reduce(function (total, curr) {
      var style = window.getComputedStyle(curr);
      var marginBottom = parseFloat(style.marginBottom);
      return total + curr.clientHeight + marginBottom;
    }, 0);
    setPlaceholderProps({
      sourceDroppableId: source.droppableId,
      targetDroppableId: target ? target.droppableId : void 0,
      clientHeight: clientHeight,
      clientWidth: clientWidth,
      clientY: clientY,
      clientX: parseFloat(computedDroppableDOMStyles.paddingLeft)
    });
  };
  var handleDragStart = React.useCallback(function (event) {
    calculatePlaceholderProps(event.draggableId, event.source);
    if (onDragStart) {
      onDragStart(event.source, dragDataByItemId.current[event.draggableId]);
    }
  }, [onDragStart]);
  var handleDragUpdate = React.useCallback(function (event) {
    if (!event.destination) {
      return;
    }
    calculatePlaceholderProps(event.draggableId, event.source, event.destination);
    if (onDragUpdate) {
      onDragUpdate(event.source, event.destination, dragDataByItemId.current[event.draggableId]);
    }
  }, [onDragUpdate]);
  var handleDragEnd = React.useCallback(function (event) {
    setPlaceholderProps(null);
    if (!onDragEnd || !event.destination) {
      return;
    }
    onDragEnd(event.source, event.destination, dragDataByItemId.current[event.draggableId]);
  }, [onDragEnd]);
  var context = React.useMemo(function () {
    return {
      canDrag: canDrag,
      canDrop: canDrop,
      onDragEnd: onDragEnd,
      placeholderProps: placeholderProps,
      setDragDataByItemId: function setDragDataByItemId(draggableId, data) {
        dragDataByItemId.current = _objectSpread(_objectSpread({}, dragDataByItemId.current), {}, _defineProperty({}, draggableId, data));
      }
    };
  }, [placeholderProps, canDrag, canDrop, onDragEnd]);
  return /*#__PURE__*/jsx(DragDropContext, {
    onDragStart: handleDragStart,
    onDragUpdate: handleDragUpdate,
    onDragEnd: handleDragEnd,
    children: /*#__PURE__*/jsx(Context.Provider, {
      value: context,
      children: children
    })
  });
};
AccordionDndContext.displayName = "AccordionDndContext";
function useAccordionDndContext() {
  return React.useContext(Context);
}
function getDraggableDom(draggableId) {
  var domQuery = "[data-rbd-draggable-id='".concat(draggableId, "']");
  return document.querySelector(domQuery);
}
function getDroppableDom(droppableId) {
  var domQuery = "[data-rbd-droppable-id=\"".concat(droppableId, "\"]");
  return document.querySelector(domQuery);
}
function getDroppableChildrenDom(droppableId) {
  var domQuery = "[data-rbd-droppable-id=\"".concat(droppableId, "\"] [data-rbd-draggable-id]");
  return document.querySelectorAll(domQuery);
}

export { AccordionDndContext, useAccordionDndContext };
